import { useQueryState } from 'nuqs'

import { LATEST_DAY, useSelectedDay } from '@hooks/useSelectedDay'
import { type StoreDayDTO, useStoreDays } from '@state/scans'

type DayScan = StoreDayDTO['scans'][number]

/** The scans to step through, newest first, as the backend sorts them. */
export function scansToStep(days: StoreDayDTO[], day: string | undefined, dayScan: string | undefined): DayScan[] {
  const ownDay = dayScan ? days.find(({ scans }) => scans.some(scan => scan.id === dayScan)) : undefined
  if (ownDay) return ownDay.scans
  if (!day) return []

  const selectedDay = day === LATEST_DAY ? days[0] : days.find(candidate => candidate.day === day)
  return selectedDay?.scans ?? []
}

export function stepsFrom(scans: DayScan[], scanId: string | undefined) {
  const index = scans.findIndex(scan => scan.id === scanId)
  if (index < 0) return { selected: undefined, newer: undefined, older: undefined }

  return { selected: scans[index], newer: scans[index - 1], older: scans[index + 1] }
}

/** The single scan shown inside the day view, and the way to another one. */
export function useDayScans() {
  const { day, dayScan } = useSelectedDay()
  const { data: days = [] } = useStoreDays()
  const [, setScan] = useQueryState('scan', { history: 'push' })
  const [, setShelf] = useQueryState('shelf')

  const scans = scansToStep(days, day, dayScan)

  return {
    dayScan,
    ...stepsFrom(scans, dayScan),
    newestScan: scans[0],
    showScan: (scanId: string | null) => {
      // an open shelf may not be in the other scan
      void setShelf(null)
      void setScan(scanId)
    },
  }
}
